<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-receipt"></i> {{ "TITLE.DOCUMENT-DETAIL" | translate }}</h4>
  </div>
  <div id="traceabilityPanel" class="{{traceabilitiesisHasMoreThan15 ? 'scrollable' : 'scrollable1'}}">
    <ul class="list-group list-group-flush">
      <li class="list-group-item" *ngFor="let traceability of traceabilities; let index=index">
              <span
                class="badge {{getBadgeClassBy(traceability.stateId)}}">{{'SELECT.OPTIONS.' + traceability._more.stateDescription | translate}}</span>
        {{traceability.createAt | dateformat}}<br>
        {{traceability._more.fullnameOperator}}
      </li>
    </ul>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-outline-danger"
            aria-label="Left Align" (click)="accept()">
      {{ "BUTTON.ACCEPT" | translate }}
    </button>
  </div>
</div>
